export default "__VITE_ASSET__0df75718__"